import { ProfiBazaColumnProps } from 'components/shared/paginatedProfiBazaTable/GridHelper';
import { InterventionListDto } from 'services/src/models';

export const interventionActionsColumn: ProfiBazaColumnProps<InterventionListDto> = {
	key: 'interventionActions',
	dataIndex: 'id',
	title: 'Akcje',
	width: 104,
	className: 'intervention-actions-column',
	alwaysVisible: true,
	alwaysLast: true,
};
